<table
  ngpDatePickerGrid
  class="sui-calendar"
  [attr.aria-label]="ariaLabel ?? null"
>
  <thead>
    <tr class="sui-calendar__weekdays">
      @if (showWeekNumbers) {
        <th scope="col" class="sui-calendar__weeknum-head" abbr="Week">#</th>
      }
      @for (wd of weekdays(); track wd.key) {
        <th scope="col" class="sui-calendar__weekday" [abbr]="wd.full">
          {{ wd.short }}
        </th>
      }
    </tr>
  </thead>
  <tbody>
    <tr *ngpDatePickerRowRender class="sui-calendar__week">
      @if (showWeekNumbers) {
        <td
          class="sui-calendar__weeknum"
          suiCalendarWeekNumber
          #wk="suiCalendarWeekNumber"
        >
          {{ wk.weekNo }}
        </td>
      }
      <td
        *ngpDatePickerCellRender="let date"
        ngpDatePickerCell
        class="sui-calendar__cell"
      >
        <button ngpDatePickerDateButton type="button" class="sui-calendar__day">
          {{ date.getDate() }}
        </button>
      </td>
    </tr>
  </tbody>
</table>
